import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickCoverComponent } from './quick-cover/quick-cover.component';
import { CoverDisplayStandaloneModule } from 'ZalamoLibrary/src/lib/ui/cover/cover/cover-display-standalone/cover-display-standalone.module';

@NgModule({
  declarations: [QuickCoverComponent],
  exports: [QuickCoverComponent],
  imports: [CommonModule, CoverDisplayStandaloneModule],
})
export class QuickCoverModule {}
